import { render } from "./AddCampaign.vue?vue&type=template&id=939b155c&scoped=true"
import script from "./AddCampaign.vue?vue&type=script&lang=js"
export * from "./AddCampaign.vue?vue&type=script&lang=js"

import "./AddCampaign.vue?vue&type=style&index=0&id=939b155c&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939b155c"]])

export default __exports__